import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { FlyMultiLineOverflowText } from '@fly/shared-ui';
import {
  InsightGroup,
  InsightItem,
  Insights,
  useContentLayoutContext,
} from '@fly/shared-ui';

import { ArtifactDetails } from '../../../store/registry.service';
import { RepositoryInsightItem } from '../../commonInsights';

export function ArtifactVersionsInsights({
  artifactDetails,
  isLoading,
  repositoryUrl,
}: {
  artifactDetails: ArtifactDetails[number] | undefined;
  isLoading?: boolean;
  repositoryUrl?: string;
}) {
  const { t } = useTranslation();
  const { owner, name } = useParams();
  const { isContainerBigger } = useContentLayoutContext();
  const latestVersion = artifactDetails?.versions
    ? artifactDetails.versions.reduce(
        (latest, current) => {
          if (
            !latest ||
            new Date(current.lastUploadTimestamp || 0) >
              new Date(latest.lastUploadTimestamp || 0)
          ) {
            return current;
          }
          return latest;
        },
        undefined as (typeof artifactDetails.versions)[number] | undefined
      )
    : undefined;

  const insights = [
    <InsightGroup
      key='overview'
      title={t('app.dashboard.insights.overview', {
        defaultValue: 'Overview',
      })}
      items={
        <>
          <InsightItem
            loading={isLoading}
            content={
              <FlyMultiLineOverflowText
                text={
                  latestVersion
                    ? t('app.dashboard.insights.latest_version_by', {
                        defaultValue:
                          'Latest version uploaded at {{timestamp}} by {{author}}.',
                        timestamp: new Date(
                          latestVersion?.lastUploadTimestamp || 0
                        ).toUTCString(),
                        author: latestVersion?.uploadedBy || 'CI',
                      })
                    : t('app.dashboard.insights.no_version_uploaded', {
                        defaultValue: 'No version uploaded',
                      })
                }
              />
            }
          />
          {repositoryUrl && (
            <RepositoryInsightItem
              href={repositoryUrl}
              isLoading={!!isLoading}
              repository={`${owner}/${name}`}
            />
          )}
        </>
      }
    />,
  ];

  return <Insights asAccordion={!isContainerBigger} items={insights} />;
}
